import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ReferenceLine, LineChart, Line, Legend, Cell } from "recharts";
import { CHARTS } from "../../data/products";

const axis = { fontSize: 12, fill: "#4A5A51", fontFamily: "JetBrains Mono" };
const tip = { contentStyle: { background: "#FBF8F1", border: "1px solid #DCD4C3", borderRadius: 10, fontSize: 13 } };
const legend = { wrapperStyle: { fontSize: 12, fontFamily: "JetBrains Mono" } };

const Frame = ({ h = 260, children }) => (
  <div style={{ height: h }} className="w-full">
    <ResponsiveContainer width="100%" height="100%">{children}</ResponsiveContainer>
  </div>
);

export const PreferenceChart = ({ h }) => (
  <Frame h={h}>
    <BarChart data={CHARTS.preference} layout="vertical" stackOffset="expand" margin={{ left: 0, right: 8 }}>
      <XAxis type="number" hide domain={[0, 100]} />
      <YAxis type="category" dataKey="code" tick={axis} width={40} axisLine={false} tickLine={false} />
      <Tooltip {...tip} formatter={(v) => `${v}%`} />
      <Legend {...legend} />
      <Bar dataKey="palativa" name="PALATIVA feed" stackId="a" fill="#1F6B45" radius={[6, 0, 0, 6]} />
      <Bar dataKey="control" name="Control feed" stackId="a" fill="#CFD9D2" radius={[0, 6, 6, 0]} />
    </BarChart>
  </Frame>
);

export const AromaChart = ({ h }) => (
  <Frame h={h}>
    <BarChart data={CHARTS.aroma} barGap={4}>
      <CartesianGrid vertical={false} stroke="#E2E8E3" />
      <XAxis dataKey="t" tick={axis} axisLine={false} tickLine={false} />
      <YAxis tick={axis} domain={[0, 100]} axisLine={false} tickLine={false} width={32} />
      <Tooltip {...tip} formatter={(v) => `${v}%`} />
      <Legend {...legend} />
      <Bar dataKey="granules" name="PALATIVA granules" fill="#8DC63F" radius={[6, 6, 0, 0]} />
      <Bar dataKey="powder" name="Plain powder" fill="#CFD9D2" radius={[6, 6, 0, 0]} />
    </BarChart>
  </Frame>
);

export const TraysChart = ({ h }) => (
  <Frame h={h}>
    <BarChart data={CHARTS.trays}>
      <CartesianGrid vertical={false} stroke="#E2E8E3" />
      <XAxis dataKey="stage" tick={axis} axisLine={false} tickLine={false} />
      <YAxis tick={axis} axisLine={false} tickLine={false} width={28} unit="%" />
      <Tooltip {...tip} formatter={(v) => `${v}%`} />
      <Legend {...legend} />
      <Bar dataKey="control" name="Control" fill="#BFD3DA" radius={[6, 6, 0, 0]} />
      <Bar dataKey="optibite" name="OPTIBITE" fill="#0B5F8A" radius={[6, 6, 0, 0]} />
    </BarChart>
  </Frame>
);

const FAN = ["#E9D46A", "#F0B53C", "#E58A1F"];
export const FanChart = ({ h }) => (
  <Frame h={h}>
    <BarChart data={CHARTS.fan}>
      <CartesianGrid vertical={false} stroke="#E2E8E3" />
      <XAxis dataKey="diet" tick={{ ...axis, fontSize: 11 }} axisLine={false} tickLine={false} interval={0} />
      <YAxis tick={axis} domain={[0, 15]} axisLine={false} tickLine={false} width={28} />
      <Tooltip {...tip} />
      <Bar dataKey="score" name="Fan score" radius={[6, 6, 0, 0]}>
        {CHARTS.fan.map((d, i) => <Cell key={d.diet} fill={FAN[i]} />)}
      </Bar>
    </BarChart>
  </Frame>
);

export const FatChart = ({ h }) => (
  <Frame h={h}>
    <LineChart data={CHARTS.fat}>
      <CartesianGrid vertical={false} stroke="#E2E8E3" />
      <XAxis dataKey="day" tick={axis} axisLine={false} tickLine={false} />
      <YAxis tick={axis} domain={[65, 95]} axisLine={false} tickLine={false} width={28} />
      <Tooltip {...tip} formatter={(v) => `${v}%`} />
      <Legend {...legend} />
      <Line dataKey="control" name="Control" stroke="#9AA8A0" strokeWidth={2} dot={{ r: 3 }} />
      <Line dataKey="lysoboost" name="LYSOBOOST" stroke="#B4471A" strokeWidth={3} dot={{ r: 4 }} />
    </LineChart>
  </Frame>
);

export const MoistureChart = ({ h }) => (
  <Frame h={h}>
    <BarChart data={CHARTS.moisture}>
      <CartesianGrid vertical={false} stroke="#E2E8E3" />
      <XAxis dataKey="s" tick={{ ...axis, fontSize: 11 }} axisLine={false} tickLine={false} interval={0} />
      <YAxis tick={axis} domain={[0, 18]} axisLine={false} tickLine={false} width={28} />
      <Tooltip {...tip} formatter={(v) => `${v}%`} />
      <Legend {...legend} />
      <Bar dataKey="control" name="Control" fill="#CFD9D2" radius={[6, 6, 0, 0]} />
      <Bar dataKey="protivex" name="PROTIVEX" fill="#E3A21A" radius={[6, 6, 0, 0]} />
    </BarChart>
  </Frame>
);

export const NoPreferenceNote = () => (
  <p className="font-mono text-[11px] text-[var(--muted)] mt-2">50% = no preference</p>
);

export { ReferenceLine };
